module.exports = __webpack_public_path__ + "img/sleeve_opening.7ea384c0.png";